import httpClient from './httpClient'

export default {
  ExternalToken: {
    Create(payload) {
      return httpClient.post('ExternalToken/Create', payload)
    },
    Update(payload) {
      return httpClient.post('ExternalToken/Update', payload)
    },
    GetById(payload) {
      return httpClient.get(`ExternalToken/GetById/${payload.id}`)
    },
    GetByDealer(payload) {
      return httpClient.get(`ExternalToken/GetByDealer/${payload.dealerId}`)
    },
  },
}
